import React, { memo, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { Row, Col, Table, Button, List, Tooltip, Checkbox, Tag } from 'antd';
import { getImageUrl, searchText } from '@utils/helper';
import { PLACE_LIST } from '@utils/constants';
import { makeSelectUser } from '@/global.selectors';

import { selectList, selectLoading, selectFilter, selectCategoryList, selectMaterialList, selectMainColorList, selectPatternList } from '../selectors';
import { onSelectProductAction, onChangeFilterAction } from '../actions';
import { COLUMN, SIZE_COLUMN, FULL_SIZE_COLUMN, PRODUCE_STATUS_LIST } from '../constants';
// import Filter from './Filter';
import Filter from '@common/ProductFilter';
import UpdateWoo from '../UpdateWoo';
import UpdateProduct from '../UpdateProduct';

class ProductMetaList extends PureComponent {
  constructor() {
    super();
    this.state = {
      showGallery: false
    }
  }
  // handleChangeFilter = (data) => {
  //   const { fieldName, fieldValue } = data;
  //   let temp = {...filter};
  //   if (fieldValue !== undefined) {
  //     temp[fieldName] = fieldValue;
  //   } else {
  //     temp = { ...FILTER }
  //   }
  //   setFilter(temp);
  //   setGridPage(1);
  // }
  handleChangeShowGallery = e => {
    this.setState({
      showGallery: e.target.checked
    })
  }
  getCategoryName = (catId = 0) => {
    if(!catId) return '';
    const cat = this.props.categoryList.find(x => x.id === catId);
    if(cat) return cat.name;
    return catId;
  }
  renderCategory = (cats = []) => {
    if(!cats.length) return '';
    return (<p>
      {cats.map(x => <Tag>{this.getCategoryName(x)}</Tag>)}
    </p>)
  }
  renderName = (_, record) => {
    let deliveryDateString = '';
    if(record.deliveryDate){
      let status = '';
      const stat = PRODUCE_STATUS_LIST.find(x => x.value === record.produceStatus);
      if(stat){
        status = ` (${stat.label})`;
      }
      deliveryDateString = <p><b><i>Dự kiến có hàng: {record.deliveryDate.format('DD/MM/YYYY')}</i></b>{status}</p>
    }
    return (<>
      <h4>{record.id ? `${record.id} - ` : ''}{record.pName}{record.sku ? ` - ${record.sku}` : ''}</h4>
      <p>{record.price} - {record.material} - {record.length ? `${record.length}cm` : ''}</p>
      {deliveryDateString}
      {this.renderCategory(record.productCategories)}
      {(this.props.user.role < 2 && record.wooProductId) ? <p><a target="_blank" rel="noopener noreferrer" href={`https://otina.n4u.vn/wp-admin/post.php?post=${record.wooProductId}&action=edit`}>{record.wooProductId}</a></p> : ''}
    </>)
  }
  renderMeta = (_, record) => {
    if (!record.metaInfo) return '';
    const parsedObj = record.metaInfo;
    const columns = [
      { title: 'Size', dataIndex: 'size' },
    ]
    COLUMN.forEach(col => {
      columns.push({
        title: col.label,
        dataIndex: col.value
      })
    });
    const dataSource = SIZE_COLUMN.map(size => {
      return {
        size,
        ...parsedObj[size]
      }
    })

    return <Table
      className='metaTable'
      bordered={false}
      pagination={false}
      size="small"
      dataSource={dataSource}
      columns={columns}
      rowKey="size" />
  }
  renderMainProps = (_, record) => {
    return (<>
      <p>Túi: {record.pocket}</p>
      <p>Xẻ: {record.sideSlit}</p>
      <p>Dài lót: {record.underlayLength}</p>
      <p>Sau lưng: {record.back}</p>
    </>)
  }
  renderGallery = text => {
    if (!text) return '';
    const images = text.split(',');
    return (<List dataSource={images} grid={{ gutter: 0, sm: 4 }} renderItem={img => <List.Item><img alt={img} height="60" src={getImageUrl(img)} /></List.Item>} />)
  }
  renderImage = (imageSrc, name, height = 100) => {
    return <img alt={name} style={{ maxHeight: height, maxWidth: 200 }} src={getImageUrl(imageSrc)} />;
  }
  render() {
    const { list, loading, onSelectProduct, filter, materialList, patternList, colorList } = this.props;
    const columns = [
      {
        title: 'Hình',
        dataIndex: 'image',
        width: 120,
        render: (text, record) => text ? <Tooltip title={this.renderImage(text, record.pName, 400)}>{this.renderImage(text, record.pName, 100)}</Tooltip> : '',// <img alt={record.pName} height="100" src={getImageUrl(text)} /> : ''
      },
      {
        title: 'Gallery',
        dataIndex: 'gallery',
        width: 240,
        render: this.renderGallery
      },
      {
        title: 'Tên SP',
        dataIndex: 'pName',
        render: this.renderName,
      },
      {
        title: 'Thông số',
        dataIndex: 'pocket',
        render: this.renderMainProps
      },
      {
        title: 'Chi tiết',
        dataIndex: 'metaInfo',
        render: this.renderMeta
      },
      {
        title: '',
        dataIndex: 'pId',
        render: (_, record) => (
          <>
            <Button icon="edit" onClick={() => {
                onSelectProduct(record);
              }} />
              <br/>
            {record.wooProductId ? <UpdateWoo singleMode={true} item={record} /> : ''}
          </>
        )

      },
    ];
    columns.push({
      title: `-`,
      dataIndex: 'inventoryQuantity',
      width: 80,
      render: (text, record) => (<>
        <div>Tổng: <b>{text}</b></div>
        {PLACE_LIST.map(branch => (<div id={branch.value}>
          {branch.label}: <b>{record[`branch${branch.value}`]}</b> <br />
        </div>))}
      </>)
    })
    FULL_SIZE_COLUMN.forEach(size => {
      columns.push({
        title: `${size.replace('size', '')}`,
        dataIndex: size,
        width: 105,
        sorter: (a, b) => a[size] - b[size],
        render: (text, record) => (<>
          <div>Tổng: <b>{text}</b></div>
          {PLACE_LIST.map(branch => (<div id={branch.value}>
            {branch.label}: <b>{record[`branch${branch.value}${size}`]}</b> <br />
          </div>))}
        </>)
      })
    });
    if (!this.state.showGallery) {
      columns.splice(1, 1);
    }
    let dataSource = list;
    if (filter.id) {
      const fId = parseInt(filter.id, 0);
      dataSource = list.filter(x => x.id === fId);
    }
    else if (filter.name || filter.material || filter.pattern || filter.color || filter.category) {
      dataSource = list.filter(x => {
        let result = true;
        if(filter.name) 
          result = searchText(x.pName, filter.name) || searchText(x.pSku, filter.name);
        if(filter.material)
          result = result && (x.material === filter.material);
        if(filter.pattern)
          result = result && (x.pattern === filter.pattern);
        if(filter.color)
          result = result && (x.mainColor === filter.color);
        if(filter.category)
          result = result && ( x.productCategories && x.productCategories.includes(parseInt(filter.category)));
        return result;
      })
    }
    if(filter.fromQuantity || filter.toQuantity){
      const fromQty = parseInt(filter.fromQuantity || 0);
      const toQty = parseInt(filter.toQuantity || 9999);
      const filterName = filter.branch ? `branch${filter.branch}` : 'inventoryQuantity';
      dataSource = dataSource.filter(x => x[filterName] < toQty && x[filterName] > fromQty);
    }
    return (
      <>
        <Row gutter={16}>
          <Col sm={12}>
            <h2>Sản phẩm</h2>
          </Col>
          <Col sm={3}><UpdateWoo /></Col>
          <Col sm={3}><UpdateProduct /></Col>
          <Col sm={6}>
            <Checkbox checked={this.state.showGallery} onChange={this.handleChangeShowGallery}>Hiện gallery</Checkbox>
          </Col>
        </Row>
        <Filter 
          materialList={materialList} 
          patternList={patternList} 
          colorList={colorList} 
          filter={filter}
          onChangeFilter={this.props.onChangeFilter}
          // onLoadCategoryList={setCategoryList}
        />
        <Row gutter={16}>
          <Col sm={24}>
            <Table
              pagination={{ showSizeChanger: true, pageSizeOptions: ['10', '20', '30', '50', '100'] }}
              loading={loading}
              dataSource={dataSource}
              columns={columns}
              rowKey="uid"
              className='smallTable'
            />
          </Col>
        </Row>
      </>
    );
  }
}

ProductMetaList.propTypes = {
  list: PropTypes.array,
  loading: PropTypes.bool,
  
};

ProductMetaList.defaultProps = {
  list: [],
  loading: false,
};

const mapStateToProps = createStructuredSelector({
  list: selectList(),
  loading: selectLoading(),
  filter: selectFilter(),
  user: makeSelectUser(),
  categoryList: selectCategoryList(),
  materialList: selectMaterialList(),
  colorList: selectMainColorList(),
  patternList: selectPatternList(),
});

const mapDispatchToProps = dispatch => ({
  onSelectProduct: (data) => dispatch(onSelectProductAction(data)),
  onChangeFilter: data => dispatch(onChangeFilterAction(data)),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, memo)(ProductMetaList);
